import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"nat"}/>
}
